/* Shared product facts: explicit catalogue values, never shipping-weight guesses. */
(() => {
  const fold = value => String(value ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[’']/g, ' ');
  const plain = html => String(html || '').replace(/<script\b[^>]*>[\s\S]*?<\/script>/gi, '').replace(/<style\b[^>]*>[\s\S]*?<\/style>/gi, '')
    .replace(/<\/(?:td|th)>/gi, '\t').replace(/<br\b[^>]*>|<\/(?:p|li|tr|h[1-6]|div)>/gi, '\n').replace(/<[^>]*>/g, '')
    .replace(/&#(x[\da-f]+|\d+);/gi, (_, n) => String.fromCodePoint(n[0].toLowerCase() === 'x' ? parseInt(n.slice(1), 16) : Number(n)))
    .replace(/&(nbsp|amp|quot|apos|deg|times|oslash|eacute|egrave|agrave);/gi, (_, n) => ({nbsp:' ',amp:'&',quot:'"',apos:"'",deg:'°',times:'×',oslash:'ø',eacute:'é',egrave:'è',agrave:'à'}[n.toLowerCase()]));
  const normalizeLabel = value => fold(value).replace(/[_-]/g, ' ').replace(/\([^)]*\)/g, '').replace(/\s+/g, ' ').trim();
  const fields = [
    ['weight','Poids','poids|poids total|weight|total weight'],
    ['total_height','Hauteur totale','hauteur totale|hauteur total|hauteur de la trottinette|total height'],
    ['bar_height','Hauteur du guidon','hauteur du guidon|hauteur de guidon|hauteur guidon|guidon hauteur|bar height'],
    ['bar_width','Largeur du guidon','largeur du guidon|largeur de guidon|largeur guidon|guidon largeur|bar width'],
    ['bar_material','Matière du guidon','matiere du guidon|matiere guidon|materiau du guidon|guidon matiere|bar material'],
    ['bar_internal_diameter','Diamètre interne du guidon','diametre interne du guidon|diametre interieur du guidon|diametre interne guidon|bar internal diameter'],
    ['bar_external_diameter','Diamètre externe du guidon','diametre externe du guidon|diametre exterieur du guidon|diametre externe guidon|bar external diameter'],
    ['clamp_model','Modèle de collier','modele de collier|collier de serrage|collier|clamp model|clamp'],
    ['compression','Type de compression','type de compression|systeme de compression|compression|compression type'],
    ['deck_width','Largeur du deck','largeur du deck|largeur deck|deck largeur|largeur du plateau|deck width'],
    ['deck_length','Longueur du deck','longueur du deck|longueur deck|deck longueur|longueur du plateau|deck length'],
    ['dropout_shape','Shape dropout','shape dropout|dropout shape|forme des dropouts|forme du dropout|dropout'],
    ['headtube_angle','Headtube angle','headtube angle|angle headtube|angle du headtube|angle de direction'],
    ['wheel_diameter','Diamètre roue','diametre roue|diametre roues|roues diametre|diametre des roues|diametre de roue|diametre de la roue|wheel diameter'],
    ['wheel_width','Largeur roue','largeur roue|largeur roues|roues largeur|largeur des roues|largeur de roue|largeur de la roue|wheel width'],
    ['assembly','Niveau d’assemblage','niveau d assemblage|niveau assemblage|assemblage|assembly'],
    ['included','Inclus','inclus|inclu|contenu du colis|contenu de la boite|included'],
    ['rider_level','Niveau du rider','niveau du rider|niveau rider|niveau conseille|niveau|rider level'],
    ['ride_style','Style de ride','style de ride|style de conduite|style ride|ride style'],
    ['axle_diameter','Diamètre de l’axe','diametre de l axe|diametre axe|essieu diametre|diametre de l essieu|axle diameter'],
    ['bar_slit','Fente du guidon','fente du guidon|guidon fendu|fente|bar slit|slit'],
    ['headset_type','Standard du jeu de direction','standard du jeu de direction|type de jeu de direction|headset type'],
    ['steerer_length','Longueur du pivot','longueur du pivot|longueur pivot|steerer length'],
    ['headtube_length','Longueur du tube de direction','longueur du tube de direction|headtube length'],
    ['truck_axle_width','Largeur de l’axe du truck','largeur axe truck|largeur de l axe du truck|truck axle width'],
    ['mounting_pattern','Perçage','percage|entraxe de fixation|mounting pattern'],
    ['wheelbase','Empattement','empattement|wheelbase']
  ];
  const aliases = new Map(fields.flatMap(([key,,names]) => [key, ...names.split('|')].map(name => [normalizeLabel(name),key])));
  const clean = value => {
    const s = plain(value).replace(/\s+/g,' ').trim();
    return !s || s.length > 180 || /^(?:[-–—?]|n\/?a|nc|null|undefined|non renseigne[e]?|non communique[e]?|inconnu[e]?|a confirmer|a definir|not available)$/i.test(fold(s)) ? '' : s;
  };
  const number = value => String(Number(value.replace(',', '.'))).replace('.', ',');
  function formatValue(key, value, label = '') {
    if (value && typeof value === 'object') value = value.value != null ? `${value.value}${value.unit ? ' '+value.unit : ''}` : '';
    let s = clean(value); if (!s) return '';
    if (key === 'compression') {
      if(/incompatible|non compatible|pas compatible|sans compression|sauf|except|adaptateur|adapter|a condition|sous reserve/.test(fold(s)))return '';
      return [...new Set((s.toUpperCase().match(/\b(?:SCS|IHC|HIC|ICS(?:-10)?)\b/g) || []))].join(' / ');
    }
    if (key === 'weight' || /height|width|length|diameter|angle/.test(key)) {
      if (/^\d+(?:[.,]\d+)?$/.test(s)) {const unit=label.match(/\((mm|cm|kg|g|°)\)/i)?.[1];if(unit)s+=' '+unit;}
      const units = key === 'weight' ? '(kg|g|grammes?|kilogrammes?)' : key === 'headtube_angle' ? '(°|deg(?:res|rees)?)' : '(mm|cm|m|pouces?|inch(?:es)?|["″])';
      const match = s.match(new RegExp('^(\\d+(?:[.,]\\d+)?)\\s*'+units+'(?=$|[\\s,;/()])','i'));
      if (!match) return /^\d+(?:[.,]\d+)?\s*(?:a|à|[-–/])\s*\d+(?:[.,]\d+)?\s*(?:mm|cm|kg|g)\b/.test(s) ? s : '';
      // Keep explicitly labelled size ranges intact instead of picking the first size.
      if (/\d+(?:[.,]\d+)?\s*(?:mm|cm|kg|g)\b/i.test(s.slice(match[0].length))) return s;
      const unit = /^(gramme|g$)/i.test(match[2]) ? 'g' : /^kilogramme/i.test(match[2]) ? 'kg' : /^deg/i.test(match[2]) ? '°' : match[2].toLowerCase();
      return `${number(match[1])}${unit === '°' ? '' : ' '}${unit}`;
    }
    return s;
  }
  const cache = new WeakMap();
  function facts(p) {
    if (cache.has(p)) return cache.get(p);
    const values = {}, evidence = {}, conflicts = new Set();
    const put = (key, value, source, label = '', overwrite = false) => {
      const formatted = formatValue(key,value,label);
      if(formatted && values[key] && values[key]!==formatted && !overwrite)conflicts.add(key);
      if (formatted && (!values[key] || overwrite)) {values[key]=formatted;evidence[key]={source,value:clean(value),label};if(overwrite)conflicts.delete(key);}
    };
    const lines = plain(p.description || p.body_html).split(/\n/).map(s=>s.replace(/^[^\p{L}\p{N}]+/u, '').trim()).filter(Boolean);
    const subject=/guidon|\bbar\b/.test(fold(p.title))?'guidon':/\bdeck\b/.test(fold(p.title))?'deck':/\broues?\b/.test(fold(p.title))?'roue':'';
    let context = '';
    for (const line of lines) {
      const lower = fold(line);
      const compression = lower.match(/\bcompression\s*:?\s*((?:scs|ihc|hic|ics(?:-10)?)(?:\s*(?:\/|,|et|ou)\s*(?:scs|ihc|hic|ics(?:-10)?))*)\b/);
      if(/compression/.test(lower) && /incompatible|non compatible|pas compatible|sans compression|adaptateur|adapter|a condition/.test(lower))conflicts.add('compression');
      if(compression && !conflicts.has('compression'))put('compression',compression[1],'description','compression');
      if (/^(?:taille|dimensions?) (?:du |de la )?(?:guidon|bar|deck|plateau)\s*:?$/.test(lower)) {context=/guidon|bar/.test(lower)?'guidon':'deck';continue;}
      if (!/^(hauteur|largeur|longueur)\s*[:\t]/.test(lower)) context='';
      let pair=line.match(/^([^:\t]{2,75})\s*[:\t]\s*(.+)$/);
      if (!pair) {
        const found=[...aliases.keys()].sort((a,b)=>b.length-a.length).find(a=>lower.startsWith(a+' '));
        if(found)pair=[line,found,line.slice(found.length).trim()];
      }
      if (!pair) continue;
      let label=normalizeLabel(pair[1]), value=pair[2].split('\t')[0].trim();
      if(context && /^(hauteur|largeur|longueur)$/.test(label))label+=' '+context;
      else if(subject && /^(hauteur|largeur|longueur|matiere|diametre interne|diametre interieur|diametre externe|diametre exterieur)$/.test(label))label+=' du '+subject;
      const key=aliases.get(label);if(key)put(key,value,'description',pair[1]);
      if (/^matiere$/.test(label) && /\bbar\b|guidon/.test(fold(value))) {
        const material=value.match(/^(.*?)(?:\bbar\b|guidon)/i)?.[1]?.trim();if(material)put('bar_material',material,'description',pair[1]);
      }
      if (/^roues?\b/.test(label)) {
        const dims=value.match(/^(\d+(?:[.,]\d+)?)\s*(?:mm)?\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*mm\b/i);
        if(dims){put('wheel_diameter',dims[1]+' mm','description',pair[1]);put('wheel_width',dims[2]+' mm','description',pair[1]);}
        else if(!/largeur|durete|noyau|poids/.test(label))put('wheel_diameter',value,'description',pair[1]);
      }
    }
    const sheet=p.technical_sheet || {};
    for(const item of [...(sheet.highlights||[]),...(sheet.groups||[]).flatMap(g=>g.items||[])]) {
      const key=aliases.get(normalizeLabel(item.label));if(key)put(key,`${item.value ?? ''}${item.unit?' '+item.unit:''}`,'fiche technique',item.label,true);
    }
    for(const item of p.spec_fields || []) {
      const key=aliases.get(normalizeLabel(item.key));if(key)put(key,item.value,'champ produit',item.key,true);
    }
    const result={values,evidence,conflicts:[...conflicts]};cache.set(p,result);return result;
  }
  function completeScooter(p) {
    const title=fold(p.title),tags=(Array.isArray(p.tags)?p.tags:String(p.tags||'').split(',')).map(fold);
    if(/guidon|\bbar\b|deck|\bgrip\b|poignee|fourche|collier|bouchon|autocollant|sticker|casque|protege|\bsac\b|support|\bstand\b|rampe|kicker|visserie|frein|finger|trampoline/.test(title))return false;
    if(/\broues?\b/.test(title) && !/(?:3|trois) roues/.test(title))return false;
    // Product type often says “trottinette freestyle” for unrelated spare parts.
    return tags.includes('trottinettes freestyles completes') || tags.includes('trottinettes enfant') || /^(?:\S+\s+){0,3}trottinette (?:freestyle|complete|enfant|pliable|3 roues)/.test(title);
  }
  function valueForVariant(key, value, p, variant) {
    if (!variant || !/weight|height|width|length|diameter/.test(key)) return null;
    const sizeIndex=(p.options || []).findIndex(option=>/^(taille|size|pointure)$/i.test(typeof option==='string'?option:option.name));
    if(sizeIndex<0)return null;
    const optionValue=v=>String(v.options?.[sizeIndex] ?? v['option'+(sizeIndex+1)] ?? '').trim();
    const selected=optionValue(variant);
    const sizes=[...new Set((p.variants || []).map(optionValue).filter(Boolean))].sort((a,b)=>b.length-a.length);
    if(!selected || !sizes.length)return null;
    const escaped=sizes.map(size=>size.replace(/[.*+?^${}()|[\]\\]/g,'\\$&')).join('|');
    // Only associate a measurement with an explicit size label, never by position.
    const pattern=new RegExp('(\\d+(?:[.,]\\d+)?)\\s*(kg|g|mm|cm|m)\\s*(?:\\([^)]*\\)\\s*)?(?:\\(('+escaped+')\\)|(?:en|taille|size)\\s+('+escaped+'))(?=$|[\\s,;/])','gi');
    const matches=[...clean(value).matchAll(pattern)];
    if(!matches.length)return null;
    const match=matches.find(m=>fold(m[3] || m[4])===fold(selected));
    return match?formatValue(key,match[1]+' '+match[2]):'';
  }
  function rows(p, variant) {
    const {values:known,evidence}=facts(p),values={...known};
    for(const key of Object.keys(values)) {
      const selected=valueForVariant(key,evidence[key]?.value,p,variant);
      if(selected!==null)values[key]=selected;
    }
    return fields.slice(0,19).filter(([key])=>values[key]).map(([key,label])=>({key,label,value:values[key]}));
  }
  function standards(p, key) {
    const {values:v,evidence,conflicts}=facts(p);
    // A product-wide description cannot establish which interface belongs to each option.
    const variableInterface=(p.options||[]).some((option,i)=>{
      const name=fold(typeof option==='string'?option:option.name);
      if(!/diametre|largeur|axe|compression|taille|size|style/.test(name))return false;
      const values=[...new Set((p.variants||[]).map(v=>String(v.options?.[i]??v['option'+(i+1)]??'')))];
      return values.length>1 && values.some(value=>/\d+(?:[.,]\d+)?\s*mm|\b(?:scs|ihc|hic|ics)\b/i.test(value));
    });
    if(variableInterface)return {variantInterface:''};
    const read=k=>{
      if(conflicts.includes(k))return '';
      const original=fold(evidence[k]?.value||'');
      if(/selon|suivant|jusqu|maximum|minimum|option|adaptateur|adapter|non compatible|incompatible/.test(original))return '';
      if(k==='bar_slit')return /^(?:non|sans|sans fente|absente|no)$/.test(fold(v[k]))?'no':/^(?:oui|avec|presente|yes)$/.test(fold(v[k]))?'yes':'';
      if(['headset_type','mounting_pattern'].includes(k))return fold(v[k]||'').trim();
      if(k==='compression')return v[k] ? v[k].toLowerCase().split(' / ').sort().join('/') : '';
      const value=v[k]?.match(/^(\d+(?:[.,]\d+)?)\s*(mm|cm|m)$/);
      return value ? String(Math.round(Number(value[1].replace(',','.'))*({mm:1,cm:10,m:1000}[value[2]])*1000)/1000) : '';
    };
    const title=fold(p.title), description=fold(plain(p.description||p.body_html));
    const compression=read('compression').split('/').filter(Boolean).sort();
    if(key==='clamp') {
      const kind=compression.includes('scs') || /\bscs\b/.test(title) ? 'scs' : compression.length || /double (?:vis|bolt)|2 (?:vis|bolt)/.test(title+' '+description) ? 'clamp' : '';
      const compatibleBar=description.match(/compatibilite\s*:\s*guidons?[^\n]*?[ø⌀]\s*(\d+(?:[.,]\d+)?)\s*mm/);
      const conditional=/compatibilite[^\n]*(?:adaptateur|cale|shim|non compatible|incompatible)/.test(description);
      return {kind,compression:compression.join('/'),outer:conditional?'':read('bar_external_diameter') || (compatibleBar ? String(Number(compatibleBar[1].replace(',','.'))) : '')};
    }
    const required={bar:['compression','bar_internal_diameter','bar_external_diameter','bar_slit'],wheel:['wheel_diameter','wheel_width','axle_diameter'],fork:['compression','wheel_diameter','wheel_width','axle_diameter','steerer_length','headset_type'],deck:['wheel_diameter','wheel_width','axle_diameter','headtube_length','headset_type'],'skate-wheel':['wheel_diameter','wheel_width','axle_diameter'],'roller-wheel':['wheel_diameter','wheel_width','axle_diameter'],truck:['truck_axle_width','mounting_pattern'],board:['deck_width','wheelbase','mounting_pattern']}[key];
    const result=required?Object.fromEntries(required.map(k=>[k,read(k)])):null;
    if(key==='bar' && result.compression?.split('/').includes('scs') && result.bar_slit==='yes')result.bar_slit='';
    return result;
  }
  function compatible(a,b,key) {
    const x=standards(a,key),y=standards(b,key);if(!x||!y)return false;
    // Missing interface dimensions are not evidence of compatibility.
    return Object.keys(x).every(k=>Boolean(x[k]) && x[k]===y[k]);
  }
  const sizeKey=value=>String(value ?? '').toUpperCase().replace(/[\/–—]/g,'-').replace(/\s+/g,'');
  function helmetSizeGuide(p) {
    if(!/\b(?:casque|helmet)\b/i.test(p.title || '') || /housse|mousse|visserie|sac/i.test(p.title || ''))return [];
    const sizeIndex=(p.options || []).findIndex(o=>/^(taille|size)$/i.test(typeof o==='string'?o:o.name));
    if(sizeIndex<0)return [];
    const option=p.options[sizeIndex];
    const sizes=option.values || [...new Set((p.variants || []).map(v=>v.options?.[sizeIndex] ?? v['option'+(sizeIndex+1)]).filter(Boolean))];
    const known=new Map(sizes.map(s=>[sizeKey(s),String(s)])),found=new Map(),conflicts=new Set();
    const measurement=(source,unitKnown=false)=>{
      const s=clean(source)+(unitKnown && !/cm\b/i.test(source)?' cm':'');
      const range=s.match(/(\d+(?:[.,]\d+)?)\s*(?:cm)?\s*(?:[-–]|à|a)\s*(\d+(?:[.,]\d+)?)\s*cm\b/i);
      const nums=range?[range[1],range[2]]:[...s.matchAll(/(\d+(?:[.,]\d+)?)\s*cm\b/gi)].map(m=>m[1]);
      const values=[...new Set(nums.map(n=>Number(n.replace(',','.'))))];
      if(!values.length || values.some(n=>n<30 || n>80) || values.some((n,i)=>i && n<values[i-1]))return '';
      if(values.length===1)return number(String(values[0]))+' cm';
      if(range || values.every((n,i)=>!i || n-values[i-1]===1))return number(String(values[0]))+' à '+number(String(values.at(-1)))+' cm';
      return values.map(n=>number(String(n))).join(' / ')+' cm';
    };
    const add=(size,source,unitKnown=false)=>{
      const key=sizeKey(size),value=measurement(source,unitKnown);if(!known.has(key)||!value)return;
      if(found.has(key) && found.get(key).value!==value)conflicts.add(key);
      found.set(key,{size:known.get(key),value,source:clean(source)});
    };
    const html=p.description || p.body_html || '';
    // Preserve table cells: never pair sizes and measurements from separate loose lists.
    for(const table of html.match(/<table\b[^>]*>[\s\S]*?<\/table>/gi) || []) {
      const tableRows=[...table.matchAll(/<tr\b[^>]*>([\s\S]*?)<\/tr>/gi)].map(r=>[...r[1].matchAll(/<t[hd]\b[^>]*>([\s\S]*?)<\/t[hd]>/gi)].map(c=>clean(c[1])));
      for(const cells of tableRows)if(cells.length===2)add(cells[0],cells[1]);
      const header=tableRows.find(r=>/^(taille|size)$/i.test(r[0]));
      if(header)for(const cells of tableRows)if(/tour de tete|head circumference/.test(fold(cells[0])) && /cm\b/i.test(cells[0]) && cells.length===header.length) {
        for(let i=1;i<header.length;i++)add(header[i],cells[i],true);
      }
    }
    for(const line of plain(html.replace(/<table\b[^>]*>[\s\S]*?<\/table>/gi,'')).split(/\n/)) {
      const markers=[...line.matchAll(/(?:^|[\s;,.])((?:X{0,3}S|X{0,3}L|M)(?:\s*[-\/–—]\s*(?:X{0,3}S|X{0,3}L|M))?)\s*(?:JUNIOR\s*)?[:(]\s*/gi)];
      markers.forEach((m,i)=>add(m[1],line.slice(m.index+m[0].length,markers[i+1]?.index ?? line.length)));
    }
    return sizes.map(s=>found.get(sizeKey(s))).filter(row=>row && !conflicts.has(sizeKey(row.size)));
  }
  const api={fields,plain,facts,rows,completeScooter,compatible,helmetSizeGuide};
  if(typeof module!=='undefined' && module.exports)module.exports=api;
  if(typeof window==='undefined')return;
  window.CabaneProductData=api;
  if(!customElements.get('cabane-size-guide'))customElements.define('cabane-size-guide',class extends HTMLElement {
    connectedCallback(){queueMicrotask(()=>{
      if(!this.isConnected)return;
      try {
        this.product=JSON.parse(this.querySelector('script').textContent);
        this.guide=helmetSizeGuide(this.product);
        this.hidden=!this.guide.length;if(this.hidden)return;
        const list=this.querySelector('dl');list.replaceChildren();
        for(const row of this.guide){const div=document.createElement('div'),dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=row.size;dd.textContent=window.CabaneI18n.text(row.value);div.append(dt,dd);list.append(div);}
        this.render(this.product.selected_variant);
        this.unsubscribe?.();
        if(typeof subscribe==='function' && typeof PUB_SUB_EVENTS!=='undefined')this.unsubscribe=subscribe(PUB_SUB_EVENTS.variantChange,event=>{
          if(event.data.sectionId===this.dataset.section)this.render(event.data.variant);
        });
      }catch(e){this.hidden=true;console.warn('Guide de taille indisponible',e.message);}
    });}
    disconnectedCallback(){this.unsubscribe?.();}
    render(variant){
      const index=this.product.options.findIndex(o=>/^(taille|size)$/i.test(o.name));
      const size=variant?.options?.[index],row=this.guide.find(r=>sizeKey(r.size)===sizeKey(size));
      const summary=this.querySelector('[data-size-summary]');summary.hidden=!row;
      summary.textContent=row?`${this.dataset.headLabel} : ${row.size} · ${row.value}`:'';
    }
  });
  if(!customElements.get('cabane-spec-sheet'))customElements.define('cabane-spec-sheet',class extends HTMLElement {
    connectedCallback(){
      queueMicrotask(()=>{
        if(!this.isConnected)return;
        this.render();
        this.unsubscribe?.();
        if(typeof subscribe==='function' && typeof PUB_SUB_EVENTS!=='undefined') {
          this.unsubscribe=subscribe(PUB_SUB_EVENTS.variantChange,event=>{
            if(event.data.sectionId===this.closest('product-info')?.dataset.section)this.render(event.data.variant);
          });
        }
      });
    }
    disconnectedCallback(){this.unsubscribe?.();}
    render(variant){
      const data=this.querySelector('script[type="application/json"]'),list=this.querySelector('dl'),section=this.closest('.cabane-quick-specs');
      if(!data||!list||!section)return;
      try {
        this.product ||= JSON.parse(data.textContent);
        const selected=variant || this.product.selected_variant;
        const specs=window.CabaneTechProfiles?.rows(this.product,selected,api) ?? rows(this.product,selected);list.replaceChildren();
        for(const row of specs){const div=document.createElement('div'),dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=window.CabaneI18n.text(row.label);dd.textContent=window.CabaneI18n.text(row.value);div.dataset.spec=row.key;div.append(dt,dd);list.append(div);}
        section.hidden=!specs.length;
      }catch(e){console.warn('Fiche technique indisponible',e.message);}
    }
  });
})();
